import React from 'react'
import PropTypes from 'prop-types'

import TextTruncate from 'react-text-truncate'

const HeaderLockup = props => (
  <div className="header-lockup">
    {props.avatarComponent}
    <div className="org-name-section-container">
      <div className="h1">{props.section}</div>
      <div className="org-name">
        <TextTruncate
          line={3}
          truncateText="..."
          text={props.organization.name}
        />
      </div>
    </div>
  </div>
)

HeaderLockup.propTypes = {
  organization: PropTypes.object.isRequired,
  section: PropTypes.string.isRequired,
  avatarComponent: PropTypes.element.isRequired
}

export default HeaderLockup



// WEBPACK FOOTER //
// ./src/components/mini/HeaderLockup.js